export type AttachmentMediaKind = 'image' | 'video' | 'audio' | 'file';

export function inferAttachmentMediaKind(file: {
  type?: string;
  mimeType?: string;
  fileUrl?: string;
  fileName?: string;
}): AttachmentMediaKind {
  const type = (file.type || '').toLowerCase();
  const mime = (file.mimeType || '').toLowerCase();
  const url = (file.fileUrl || '').toLowerCase();
  const name = (file.fileName || '').toLowerCase();

  if (type === 'image' || mime.startsWith('image/')) return 'image';
  if (type === 'video' || mime.startsWith('video/')) return 'video';
  if (type === 'audio' || mime.startsWith('audio/')) return 'audio';

  if (/\.(mp4|webm|mov|mpeg)(\?|$)/.test(url) || /\.(mp4|webm|mov)$/.test(name)) {
    return 'video';
  }
  if (/\.(jpe?g|png|gif|webp)(\?|$)/.test(url)) return 'image';
  if (/\.(webm|mp3|m4a|ogg)(\?|$)/.test(url)) return 'audio';

  return 'file';
}

export function isPdfAttachment(file: {
  type?: string;
  mimeType?: string;
  fileUrl?: string;
  fileName?: string;
}): boolean {
  const mime = (file.mimeType || '').toLowerCase();
  const url = (file.fileUrl || '').toLowerCase();
  const name = (file.fileName || '').toLowerCase();
  return mime.includes('pdf') || url.endsWith('.pdf') || name.endsWith('.pdf');
}
